module.exports = __webpack_public_path__ + "static/media/NO_SUGAR.d095ad43.svg";